import * as Yup from "yup";

export const CountrySchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  code: Yup.string().required("Code is required"),
  isdCode: Yup.string().required("Isd Code is required"),
  status: Yup.boolean().required("Status is required"),
});
